import { apiFetch } from "./apiFetch";

// Self-service "apply to become a therapist" endpoints — used both right
// after registration (when the user toggles "register as therapist") and
// later from Account Settings for an existing patient account.

// One call per file — apiFetch omits Content-Type for FormData bodies so the
// browser can set the multipart boundary itself.
export const uploadTherapistApplyDocument = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiFetch("/account/therapist-apply/upload", {
    method: "POST",
    body: formData,
  }).then((d) => d.data); // { s3_key, name, content_type }
};

export const submitTherapistApply = ({ practiceName, practiceCity, practiceEmail, documents }) =>
  apiFetch("/account/therapist-apply", {
    method: "POST",
    body: JSON.stringify({
      practiceName,
      practiceCity,
      practiceEmail,
      documents: documents.map(({ s3_key, name }) => ({ s3_key, name })),
    }),
  }).then((d) => d.data); // { id, status, submittedAt }

// The rejection/revocation reason is an internal note for staff only and is
// never included here — status is one of none | pending | approved |
// rejected | revoked, with no reason text for the applicant to see.
export const fetchTherapistApplicationStatus = () =>
  apiFetch("/account/therapist-application").then((d) => d.data); // { status }
